/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTag} from '../api'

 export const useQueryGetTag = createReactQueryHook('getTag', getTag)
